import React from 'react';
import { Panel, PanelTheme, PanelBorderRadius } from '@apply/components';
import { Button, ButtonTheme } from '@apply/components';
import { Signature } from './Signature';
import '../../scss/controls/_signpage.scss';

interface SignaturePageProps {
    agreementHeader?: React.ReactNode;
    agreementBody: React.ReactNode;
    acceptButtonText?: string;
    firstName: string;
    lastName: string;
    onSubmitAgreement: () => void;
    onDeclineAgreement: () => void;
    disableButtons?: boolean;
    maxWidth?: string;
}

export const SignaturePage: React.FC<SignaturePageProps> = ({
    agreementHeader,
    agreementBody,
    acceptButtonText,
    firstName,
    lastName,
    onSubmitAgreement,
    onDeclineAgreement,
    disableButtons = false,
    maxWidth,
}) => {
    const signpageStyle = maxWidth ? { maxWidth } : {};

    return (
        <div
            className='signpage'
            style={signpageStyle}
        >
            <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {agreementHeader && <div className='header'>{agreementHeader}</div>}
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                    padding={32}
                >
                    {agreementBody}
                    <Signature
                        firstName={firstName}
                        lastName={lastName}
                    />
                </Panel>
            </div>
            <div
                style={{ maxHeight: '20vh' }}
                className='submit-button'
            >
                <div className='accept'>
                    <Button
                        id='primaryButton'
                        theme={ButtonTheme.Primary}
                        width='200px'
                        handleClick={onSubmitAgreement}
                        disabled={disableButtons}
                    >
                        {acceptButtonText ?? 'Accept'}
                    </Button>
                </div>
                <Button
                    id='declineButton'
                    theme={ButtonTheme.Decline}
                    width='200px'
                    handleClick={onDeclineAgreement}
                    disabled={disableButtons}
                >
                    Decline
                </Button>
            </div>
        </div>
    );
};
